export const MEDIA_IMAGE_CONTENT_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/heic',
  'image/heif',
] as const;

export const MEDIA_IMAGE_FILE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.webp', '.heic', '.heif'];

export const MEDIA_VIDEO_CONTENT_TYPES = ['video/mp4', 'video/quicktime', 'video/webm'] as const;

export function buildAcceptAttribute(contentTypes: readonly string[]): string {
  return [...contentTypes, ...MEDIA_IMAGE_FILE_EXTENSIONS].join(',');
}

export function isAcceptedContentType(file: File, allowedContentTypes: readonly string[]): boolean {
  if (allowedContentTypes.includes(file.type)) {
    return true;
  }
  const hasUndeclaredMimeType = file.type.length === 0 || file.type === 'application/octet-stream';
  if (hasUndeclaredMimeType === false) {
    return false;
  }
  const lowerCaseName = file.name.toLowerCase();
  if (lowerCaseName.endsWith('.heic') && allowedContentTypes.includes('image/heic')) {
    return true;
  }
  if (lowerCaseName.endsWith('.heif') && allowedContentTypes.includes('image/heif')) {
    return true;
  }
  return false;
}
